<mat-icon
  [svgIcon]="iconName"
  [ngStyle]="getSvgIconStyle()"
  [id]="'shared-custom-svg-icon-' + iconName"
></mat-icon>
